export const UTM_STORAGE_KEY = 'utm_data';

export const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'] as const;
